/* eslint-disable prettier/prettier */
import localize from '../localize';
import vardagaRefinements from './vardaga-2021';
import altidenRefinements from './altiden-2021';

const defaultRefinements = {
  'taxonomies.servicecategory': localize('taxonomies')
    ? localize('taxonomies')
        .replace(/,\s*$/, '')
        .split(',')
        .map((x) => x.trim())
    : [],
  'taxonomies.serviceregion': localize('taxonomies')
    ? localize('taxonomies')
        .replace(/,\s*$/, '')
        .split(',')
        .map((x) => x.trim())
    : [],
};

var exportedRefinements = defaultRefinements;

const theme = localize('svb_active_theme') || '';

if (theme === 'vardaga-2021') {
  exportedRefinements = vardagaRefinements;
}

if (theme === 'altiden-2021') {
  exportedRefinements = altidenRefinements;
}

export default exportedRefinements;
